// extracted by mini-css-extract-plugin
module.exports = {"titlesBox":"home-module--titlesBox--wOvR6","sectionTitle":"home-module--sectionTitle--3SXeQ"};